import ServiceTemplate from '@/components/ServiceTemplate';

export default function CompanyRenewal() {
  const data = {
    title: 'Company Renewal Services',
    subtitle: 'Annual report filing and business renewal services to maintain good standing.',
    overviewTitle: 'Maintaining Your Company\'s Good Standing',
    overviewImage: 'https://images.unsplash.com/photo-1631286434951-caa3dcab4d1b',
    description: [
      'Most states require annual reports or renewal filings to maintain your company\'s good standing. Failure to file can result in administrative dissolution, late fees, and loss of liability protection.',
      'Our renewal service handles all annual filing requirements including annual reports, franchise taxes, and registered agent renewals to keep your business in compliance.',
      'We monitor deadlines and ensure timely filing of all required renewals, so you can focus on running your business without worrying about compliance deadlines.'
    ],
    benefits: [
      { title: 'Good Standing', description: 'Maintain active business status with the state.' },
      { title: 'Liability Protection', description: 'Preserve personal liability protection.' },
      { title: 'Avoid Penalties', description: 'Prevent late fees and penalties.' },
      { title: 'Deadline Management', description: 'Never miss filing deadlines.' },
      { title: 'Compliance Peace of Mind', description: 'Focus on business, not paperwork.' },
      { title: 'Certificate Updates', description: 'Receive updated certificates of good standing.' }
    ],
    process: [
      { title: 'Assessment & Planning', description: 'Evaluate current status and plan all necessary steps for successful completion.' },
      { title: 'Documentation & Filing', description: 'Prepare and file all required documents with state and federal authorities.' },
      { title: 'Verification & Finalization', description: 'Ensure proper processing, obtain confirmations, and finalize all requirements.' }
    ],
    pricing: [
      {
        name: 'Basic',
        description: 'Essential formation',
        price: '$299',
        period: '+ state fees',
        features: [
          'Entity formation filing',
          'Name availability check',
          'EIN application',
          'Basic documents',
          'Email support',
          'Document delivery'
        ]
      },
      {
        name: 'Professional',
        description: 'Complete package',
        price: '$599',
        period: '+ state fees',
        featured: true,
        features: [
          'Everything in Basic',
          'Custom agreements',
          'Tax consultation',
          'Compliance setup',
          'Registered agent (1 year)',
          'Priority processing',
          'Phone support'
        ]
      },
      {
        name: 'Enterprise',
        description: 'Full-service solution',
        price: '$999',
        period: '+ state fees',
        features: [
          'Everything in Professional',
          'Multi-state filing',
          'Advanced structuring',
          'Annual compliance',
          'Quarterly reviews',
          'Dedicated attorney',
          'Unlimited consultations'
        ]
      }
    ],
    faqs: [
      { question: 'What happens if I don\'t file annual reports?', answer: 'Your business can be administratively dissolved, losing liability protection, ability to conduct business, and requiring costly reinstatement.' },
      { question: 'When are annual reports due?', answer: 'Due dates vary by state, typically based on formation anniversary date or calendar deadlines. We monitor your specific deadlines.' },
      { question: 'What is franchise tax?', answer: 'Franchise tax is an annual tax some states charge for the privilege of doing business, separate from income tax.' },
      { question: 'How much does renewal cost?', answer: 'State fees vary from $50-$800 depending on state and entity type, plus our service fee for preparation and filing.' },
      { question: 'Can I reinstate a dissolved company?', answer: 'Yes, most states allow reinstatement within certain timeframes, though additional fees and back reports may be required.' },
      { question: 'What information is required?', answer: 'Reports typically require updated officer/director information, business address, registered agent details, and sometimes financial information.' },
      { question: 'Do all states require annual reports?', answer: 'Most states require some form of annual filing, though requirements and terminology vary. A few states have biennial or no reporting requirements.' },
      { question: 'What is a Certificate of Good Standing?', answer: 'An official state document verifying your business is current with all filings and in good standing, often required for loans or contracts.' }
    ]
  };

  return <ServiceTemplate {...data} />;
}
